
class announcementBar extends HTMLElement {
    constructor() {
        super();
        this.closeBtn = this.querySelector("[js-close-announcement-bar]");

        if(this.closeBtn) {
            this.closeBtn.addEventListener('click', () => {
                this.disabledAnnouncementBar();
            });
        };
    };

    disabledAnnouncementBar() {
        $(this).slideUp();
    }
}

customElements.define('announcement-bar', announcementBar);